import React from "react";
import { Button } from "@mui/material";
import { LegalDocumentModal, TermsOfUse } from "components/LegalDocuments";

type Props = {
  open: boolean;
  handleClose: () => void;
};

export const TermsOfUseModal = ({ open, handleClose }: Props) => (
  <LegalDocumentModal
    open={open}
    title="Terms of Use"
    handleClose={handleClose}
    actions={
      <Button
        onClick={handleClose}
        sx={{
          width: "200px",
          fontSize: "14px",
          bgcolor: "secondary.main",
          color: "common.white",
        }}
      >
        CLOSE
      </Button>
    }
  >
    <TermsOfUse defaultExpanded />
  </LegalDocumentModal>
);
